// extracted by mini-css-extract-plugin
export default {"card":"GradeCard_card__8lW1j","subject":"GradeCard_subject__Kh-z+"};